import { render, staticRenderFns } from "./B2CV2KpiCard.vue?vue&type=template&id=36efe9e2&scoped=true&"
import script from "./B2CV2KpiCard.vue?vue&type=script&lang=js&"
export * from "./B2CV2KpiCard.vue?vue&type=script&lang=js&"
import style0 from "./B2CV2KpiCard.vue?vue&type=style&index=0&id=36efe9e2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36efe9e2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard})
